import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  init(): void {
    const { hostname } = globalThis.location;
    const isDeployed = environment.deployedDomains.some(d => hostname.endsWith(d));
    if (!isDeployed) return;
    if ((globalThis.navigator as { webdriver?: boolean }).webdriver) return;

    const gaId = environment.googleAnalyticsId;

    const win = globalThis as unknown as { dataLayer: unknown[]; gtag: (...args: unknown[]) => void };
    win.dataLayer = win.dataLayer || [];
    // gtag.js uses Object.prototype.toString.call(item) === '[object Arguments]' to detect commands —
    // plain arrays from rest params are silently skipped, so IArguments is required here.
    // eslint-disable-next-line prefer-rest-params
    win.gtag = function() { win.dataLayer.push(arguments); };

    const script = document.createElement('script');
    script.async = true;
    script.src = `${environment.googleTagManagerUrl}?id=${gaId}`;
    document.head.appendChild(script);

    win.gtag('js', new Date());
    win.gtag('config', gaId);
  }

  trackEvent(eventName: string, params?: Record<string, unknown>): void {
    const gtag = (globalThis as { gtag?: (...args: unknown[]) => void }).gtag;
    gtag?.('event', eventName, params);
  }
}
